export default {
    methods: {
        availableQuantity(item) {
            const obj = item.quantity.find(q => q.type === 'active');

            return obj && obj.count ? obj.count: 0;
        },
        condition(item, subject = 'disc') {
            const obj = item.condition.find(c => c.subject === subject);

            return obj && obj.grade ? obj.grade : '';
        },
        conditions(item) {
            return item.condition.map(c => {
                return {
                    grade: c.grade,
                    subject: c.subject ? c.subject.charAt(0).toUpperCase() + c.subject.slice(1) : null,
                    notes: c.notes.join(', '),
                }
            });
        },
        artist(item) {
            if (item.release.artist && item.release.artist.first) {
                return [ item.release.artist.first, item.release.artist.last ].join(' ');
            }

            return item.release.artist ? item.release.artist.last : '';
        },
        title(item) {
            return item.release.titles ? item.release.titles.join(' / ') : '';
        },
        edition(item) {
            return item.release.pressing.filter(pressing => {
                if (pressing.type === 'edition') {
                    return pressing.text;
                }
            });
        },
        pressing(item) {
            return item.release.pressing.map(p => {
                return p.text;
            });
        },
        pressingFull(item) {
            let pressings = {};

            item.release.pressing.forEach(p => {
                let type = p.type ? p.type.charAt(0).toUpperCase() + p.type.slice(1) : '';

                if (!pressings[type]) {
                    pressings[type] = [];
                }

                pressings[type].push(p.text);
            });

            for (let type in pressings) {
                if (pressings[type]) {
                    pressings[type] = pressings[type].join(', ');
                }
            }

            return pressings;
        },

        notes(item) {
            let notes = [];

            item.notes.forEach(note => {
                if (!note.type) {
                    notes.push(note.text);
                }
            });

            return notes;
        },

        format(media = []) {
            const formats = media.map(item => {
                let countStr = item.count > 1 ? `${item.count} x ` : ``;
                const speed = item.speed ? `(${item.speed} RPM)` : '';
                const attributes = this.buildMediaAttributes(item);
                if (item.duration === 'CD' || item.duration === 'CD Single' || item.duration === 'Cassette' || item.duration === 'Cassette Single') {
                    return `${countStr} ${item.duration} ${attributes}`
                } 
                return `${countStr}${item.size}" ${item.duration} ${speed} ${attributes}`;

            });

            return formats.filter((f)=> f !== null).join(', ');
        },
        buildMediaAttributes(media) {
            if (media.attributes) {
                return media.attributes.join(', ');
            }

            return [];
        },
        location(item) {
            return item.listing.location || '';
        },
        price(item) {
            return item.listing.price || 0;
        }
    }
}